import { render, staticRenderFns } from "./LeadershipAdmin.vue?vue&type=template&id=586061aa&scoped=true"
import script from "./LeadershipAdmin.vue?vue&type=script&lang=js"
export * from "./LeadershipAdmin.vue?vue&type=script&lang=js"
import style0 from "./LeadershipAdmin.vue?vue&type=style&index=0&id=586061aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586061aa",
  null
  
)

export default component.exports